import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, FormGroup, Div, Forms, H3, LabelField } from './Accounting.styles';
import apis from '../../api';
import { saveAs } from 'file-saver';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import useParamsAccounting from '../../helpers/useParamsAccounting'
import useParamsAccountingPlano from '../../helpers/useParamsAccountingPlano'
import dateFormat from '../../services/DateFormat.service';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { addLocale } from 'primereact/api'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { ProgressBar } from 'primereact/progressbar';
import { CsvSaver } from 'csv-saver';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Accounting.css'
import { excelExport } from '../../services/excelExport.service';
import { excelReport } from '../../services/excelReport.service';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Accounting
Description : Generación de reporte.
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina - Creación 
05/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Accounting() {

    // Declaración de constantes
    const toast = useRef(null);
    const [params] = useParamsAccounting();
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [calendar, setCalendar] = useState("");
    const [typeFile, setTypeFile] = useState("");
    const { paramsPlano, name, setName } = useParamsAccountingPlano();
    const [accounting, setAccounting] = useState([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenRA, setIsOpenRA] = React.useState(false);
    const [isOpenPlano, setIsOpenPlano] = React.useState(false);
    const [isOpenAcum, setIsOpenAcum] = React.useState(false);
    const [consultado, setConsultado] = useState(false)
    const [selectedRows, setSelectedRows] = useState(null);
    const [accountingPlano, setAccountingPlano] = useState([]);
    const [listaArchiveType, setListaArchiveType] = useState([]);
    const [loadingArchivo, setLoadingArchivo] = useState(false);
    const [loadingGenerar, setLoadingGenerar] = useState(false);
    const [loadingProcesar, setLoadingProcesar] = useState(false);
    const [loadingAcomular, setLoadingAcomular] = useState(false);
    const [loadingDeshacer, setLoadingDeshacer] = useState(false);
    const [loadingConsultar, setLoadingConsultar] = useState(false);
    const [loadPage, setLoadPage] = useState(false)
    const elementWidth = { width: "20rem", justifySelf: "center" }
    const headers = { authorization: localStorage.getItem('token') }
    const [listaOptionsCalendar, setOptionsCalendar] = useState([{ "value": "", "label": "" }]);
    const [dataTable, setDataTable] = useState([])
    const [headersTable, setHeadersTable] = useState([])
    const [nameTable, setNameTable] = useState("")

    const [errorRows, setErrorRows] = useState([])
    const [isOpenErrors, setIsOpenErrors] = useState(false)

    // Funciones de inicialización Lista de tipos de archivos
    useEffect(() => {
        apis.getAccountListDocumentType(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let archiveType = res.data["FILES_CTB"][0]["LITE_PLANOS_CONTABLES"]
            // let contenidoArchiveType = []
            // archiveType.forEach(element => {
            //     contenidoArchiveType.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
            // })
            setListaArchiveType(archiveType);
        })
        listCalendar();
    }, []);

    // Funciones de inicialización de parametro pinEntity
    useEffect(() => {
        const accountingTemplate = async () => {
            let plantilla = []
            params.forEach((p) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setAccounting(plantilla)
        }
        accountingTemplate()
    }, [params]);

    // Funciones de inicialización de parametro pinEntity para planos contables
    useEffect(() => {
        const plainTemplate = async () => {
            let plantilla = []
            paramsPlano.forEach((p) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setAccountingPlano(plantilla)
        }
        plainTemplate()
    }, [paramsPlano]);

    useEffect(() => {
        infoTabla()
    }, [])

    // Formato para componente calendar
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    // Funcion que obtiene la acción de formulario
    function handleSubmit(event) {
        event.preventDefault();
    }

    // Funcion para mostrar modal
    const showModalRA = () => {
        setIsOpenRA(true);
    };

    // Funcion para ocultar modal y limpiar campos
    const showModal = () => {
        setIsOpen(true);
        setCalendar("")
    }

    // Funcion para ocultar modal
    const hideModal = () => {
        setIsOpen(false);
        setConsultado(false)
    }

    // Funcion para abrir modal
    const showModalPlano = () => {
        setIsOpenPlano(true);
    }

    // Funcion para ocultar modal
    const hideModalPlano = () => {
        setIsOpenPlano(false);
    }

    // Funcion para ocultar modal
    const hideModalRA = () => {
        setIsOpenRA(false);
    };
    const showModalAcum = () => {
        setIsOpenAcum(true);
    };

    const hideModalAcum = () => {
        setIsOpenAcum(false);
    };

    // Funcion para cargar select de calendario
    async function listCalendar() {
        await apis.getValueListCalendar('CB', headers).then(res => {
            let data = res.data.CALENDAR
            let tipoCalendar = data;
            let contenidoTipoCalendar = [];
            tipoCalendar.forEach(res =>
                contenidoTipoCalendar.push({ "value": '' + res.ID_CALENDAR + '', "label": '' + res.DETAIL + '' })
            )
            setOptionsCalendar(contenidoTipoCalendar)
        }).catch(err => {
            setOptionsCalendar([])
        })
    }

    // Funcion para cargar datos de tabla
    async function setTabla() {
        setLoadingConsultar(true)
        const _calendario = calendar.value
        try {
            await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
                if (res.data["PROCESS"].length > 0) {
                    let data = res.data["PROCESS"]
                    setRows(data)
                    setConsultado(true)
                    setLoadingConsultar(false)
                }
                else {
                    setLoadingConsultar(false)
                    setRows([])
                }
            })
        }
        catch (err) {
            setLoadingConsultar(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const infoTabla = async () => {
        try {
            await apis.getAccountTable(localStorage.getItem('entity'), localStorage.getItem("client"), headers).then(res => {
                let tabla = res.data
                let nombre = tabla.NAME
                let data = tabla['CTB_CONCILIATION']
                let headers = data[0]
                data.shift()
                let info = data

                setNameTable(nombre)
                setHeadersTable(headers)
                setDataTable(info)
                setLoadPage(true)
            })
        }
        catch (err) {
            setLoadPage(true)
            console.log(err)
        }
    }

    // Funcion para crear archivo plano
    function createFile(data) {
        let file_name = data.NAME
        let text = data['DETAIL'];
        let contenido = "";
        text.forEach(res => {
            contenido += res.LINE + '\r\n';
        })
        const blob = new Blob([contenido], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, file_name);
    }

    // Funcion para procesar, acomular o reversar contabilidad
    async function process(action) {
        const p = {
            ID_CALENDAR: calendar.value,
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            ACTION: action
        }

        if (action == "PRO") {
            setLoadingProcesar(true)
        } if (action == "CLO") {
            setLoadingAcomular(true)
        } if (action == "REV") {
            setLoadingDeshacer(true)
        }

        await apis.executeProcess(p, headers).then(res => {
            switch (action) {
                case "PRO":
                    setLoadingProcesar(false)
                    setTabla()
                    infoTabla()
                    return toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'PROCESADO CON EXITO', life: 4000 });
                case "CLO":
                    setLoadingAcomular(false)
                    hideModalAcum()
                    setTabla()
                    infoTabla()
                    return toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'ACUMULADO CON EXITO', life: 4000 });
                case "REV":
                    setLoadingDeshacer(false)
                    setTabla()
                    infoTabla()
                    return toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'REVERSADO CON EXITO', life: 4000 });
            }
        }).catch(err => {
            setLoadingDeshacer(false)
            setLoadingAcomular(false)
            setLoadingProcesar(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })
    }

    // Funcion para generar reporte de contabilidad
    async function postAccountingReport() {
        setLoadingGenerar(true)
        let finalReport = []
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: _entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        accounting.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        accounting.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {
            await apis.postReportAccounting(report, headers).then(res => {
                setLoadingGenerar(false)
                finalReport = res.data
                console.log(finalReport)
                excelReport(finalReport, 'reporte_Contabilidad')
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de Contabilidad generado existosamente" });
            })
        }
        catch (err) {
            setLoadingGenerar(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    // Funcion para generar reporte de archivo plano de contabilidad
    async function postAccountingReportPlano() {
        setLoadingArchivo(true)
        let finalReport = []
        const client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const name = typeFile.detail_id
        let report = {
            CLIENT: client,
            ENTITY: _entity,
            OPTION: '1',
            NAME: name,
            REPORTS: []
        }
        let max = 0
        accountingPlano.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        accountingPlano.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {
            await apis.postReportAccount(report, headers).then(res => {
                let data = res.data["SHEETS"][0]
                finalReport = res.data
                setLoadingArchivo(false)
                switch (data.TYPE_FILE) {
                    case "XLS":
                        excelReport(finalReport, 'reporte_Contabilidad')
                        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de Contabilidad generado existosamente" });
                        break
                    case "TXT":
                        createFile(data)
                        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de Contabilidad generado existosamente" });
                        break
                    case "CSV":
                        csvReport(data)
                        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de Contabilidad generado existosamente" });
                        break
                }
            })
        }
        catch (err) {
            setLoadingArchivo(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function csvReport(reporte) {
        const csvSaver = new CsvSaver({ delimiter: ';' });
        let extension = ".csv"
        let data = reporte.DETAIL
        csvSaver.addString("")
        csvSaver.addNewLine()
        data.forEach(n => {
            let linea = n.LINE
            csvSaver.addString(linea)
            csvSaver.addNewLine();
        })
        csvSaver.saveAs(reporte.NAME + extension);
    }

    // Encabezado de la tabla dentro del modal
    const tableHeader = (
        <div className="table-header">
            <Button icon="pi pi-refresh" tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm" onClick={() => setTabla()} />
        </div>
    );

    // imprimir mensaje de error en la tabla cuando su estado es error
    const rowClassName = (rowData) => {
        return { 'error-row': (rowData["STATUS"] === "ERROR") };
    }

    const rowClassName2 = (rowData) => {
        let style = { 'warn-row': (rowData["COL4"] !== "0") }
        if (rowData.COL1 === 'Total') {
            if (rowData.COL4 !== "0") {
                style = { 'warn-row font-bold': (rowData["COL4"] !== "0") }
            }
            else {
                style = { 'font-bold': (rowData["COL4"] === "0") }
            }
        }
        return style
    }

    const formatCurrency = (value) => {
        let currency = parseInt(value)
        return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
    }

    const valueBodyTemplateCol2 = (rowData) => {
        if (rowData.COL2) {
            return formatCurrency(rowData.COL2);
        }
        else {
            return null;
        }
    }

    const valueBodyTemplateCol3 = (rowData) => {
        if (rowData.COL3) {
            return formatCurrency(rowData.COL3);
        }
        else {
            return null;
        }
    }

    const valueBodyTemplateCol4 = (rowData) => {
        if (rowData.COL4) {
            return formatCurrency(rowData.COL4);
        }
        else {
            return null;
        }
    }

    // Constante para cambio de pagina en la tabla
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    // Función para mostrar porcentaje de avance de la carga de datos
    const percentageBodyTemplate = (rowData) => {
        return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
    }

    // Nombre de las opciones de filtrados en la tabla
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    //Encabezado del modal liquidar contabilidad
    const headerLN = (
        <div>
            <h3>Seleccionar calendario para liquidar Contabilidad</h3>
        </div>
    )

    const actionBodyTemplateErrors = (rowData) => {
        console.log(rowData.ERRORS)
        return (
            <div>
                {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
            </div>
        )
    }

    //Pie de pagina del modal liquidar contabilidad
    const footerLN = (
        <>
            <div>
                <Button onClick={() => process("PRO")} disabled={calendar.value == undefined} loading={loadingProcesar} label='Procesar'></Button>
                <Button onClick={() => process("REV")} disabled={calendar.value == undefined} loading={loadingDeshacer} label='Deshacer'></Button>
                <Button onClick={showModalAcum} disabled={calendar.value == undefined} label='Acumular'></Button>
            </div>
            {consultado === true && calendar.value != undefined ?
                <div className="datatable-style-demo">
                    <DataTable className="text-xs" header={tableHeader} value={rows} first={first2} rows={rows2} onPage={onCustomPage2}
                        responsiveLayout="scroll" selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
                        size="small"
                        rowClassName={rowClassName}
                    >
                        <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplateErrors}></Column>
                        <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                        <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
                        <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
                        <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
                        <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
                        <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
                        <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
                        <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
                        <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
                    </DataTable>
                </div>
                : null
            }
        </>
    );

    // Encabezzado del modal generar archivo plano
    const headerPlano = (
        <div>
            <h3>Generar Plano Contable</h3>
        </div>
    )

    // Pie de pagina del modal generar archivo plano
    const footerPlano = (
        <div>
            <Button block type="submit" loading={loadingArchivo} onClick={postAccountingReportPlano} disabled={typeFile === undefined} label='Generar archivo'></Button>
        </div>
    );

    const headerAcum = (
        <div>
            <h3>¿Desea realizar la acumulación del proceso?</h3>
        </div>
    )

    const footerAcum = (
        <div>
            <Button label="Si" loading={loadingAcomular} onClick={() => { setLoadingAcomular(true); process("CLO") }} />
            <Button label="No" onClick={hideModalAcum} />
        </div>
    );

    // Configuración para parametros variables tipo select
    function handleChange(e, d, index) {
        setAccounting(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo calendar
    async function handleChangeDate(e, d, index) {
        let date = dateFormat(e.value)
        setAccounting(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo text
    async function handleChangeText(e, d, index) {
        setAccounting(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo select para archivo plano
    function handleChangePlano(e, d, index) {
        setAccountingPlano(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo calendar para archivo plano
    async function handleChangeDatePlano(e, d, index) {
        let date = dateFormat(e.value)
        setAccountingPlano(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo text para archivo plano
    async function handleChangeTextPlano(e, d, index) {
        setAccountingPlano(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Encabezado  para modal de los parametros dinamicos
    const headerRA = (
        <div>
            <h3>Parámetros reporte de Contabilidad</h3>
        </div>
    )

    // Pie de pagina del modal de los parametros dinamicos
    const footerRA = (
        <div>
            <Button loading={loadingGenerar} onClick={() => postAccountingReport()} label='Generar'></Button>
        </div>
    );

    // Return que entrega la pantalla
    return (
        <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">

            <Toast ref={toast} />

            <Dialog header={headerPlano} footer={footerPlano} visible={isOpenPlano} position="top" style={{ width: "32rem" }} draggable={false} resizable={false} modal onHide={hideModalPlano}>

                <div className='block'>
                    <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                </div>

                <LabelField htmlFor="label">Tipo de archivo contable *</LabelField>
                <Dropdown showClear style={elementWidth} value={typeFile} options={listaArchiveType} optionLabel="description"
                    placeholder={"Seleccione el tipo de archivo"} onChange={(e) => { setTypeFile(e.value); setName(e.value && e.value.detail_id ? e.value.detail_id : "") }}
                />

                {typeFile ?
                    <div>
                        {paramsPlano.map((d, index) => {
                            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && accountingPlano.length > 0 && typeof accountingPlano[index] !== "undefined") {
                                let label = d.LABEL

                                if (d.REQUIRED == "1") {
                                    label = label + "*"
                                }
                                switch (d.TYPE) {
                                    case "LIST":
                                        let options = []
                                        if (d.REQUIRED === "1") {
                                            options = [...d.OPTIONS]
                                        }
                                        else {
                                            options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                        }
                                        return (<>
                                            <LabelField htmlFor="label">{label}</LabelField>
                                            <Dropdown
                                                key={index}
                                                style={elementWidth}
                                                value={accountingPlano[index]["NAME"]}
                                                options={options}
                                                filter filterBy="NAME"
                                                optionLabel="NAME"
                                                placeholder={accountingPlano[index]["NAME"] ? accountingPlano[index]["NAME"] : "Seleccione"}
                                                onChange={(e) => handleChangePlano(e, d, index)}
                                            />
                                        </>
                                        );
                                    case "DATE":
                                        return (<>
                                            <LabelField htmlFor="label">{label}</LabelField>
                                            <Calendar key={d} style={elementWidth} id="navigators" value={accountingPlano[index].CODE}
                                                onChange={(e) => handleChangeDatePlano(e, d, index)}
                                                locale="es" dateFormat="dd-mm-yy" showIcon placeholder={accountingPlano[index].CODE}
                                                yearRange="2010:2030" /></>
                                        );
                                    case "":
                                        return null;
                                    default:
                                        return (<>
                                            <LabelField htmlFor="label">{label}</LabelField>
                                            <InputText
                                                key={d}
                                                style={elementWidth}
                                                id="label2"
                                                type="text"
                                                value={accountingPlano[index].NAME}
                                                onChange={(e) => handleChangeTextPlano(e, d, index)}
                                            /></>
                                        )
                                }
                            }
                        })} </div>
                    : null
                }
            </Dialog>

            <Dialog header={headerLN} footer={footerLN} visible={isOpen} maximizable
                position="top" style={{ width: "40rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div className='block'>
                    <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                </div>

                <LabelField htmlFor="label">Calendario liquidación de nómina *</LabelField>

                <div className="p-inputgroup">
                    <Dropdown style={elementWidth} value={calendar.value}
                        filter showClear filterBy="label"
                        options={listaOptionsCalendar} placeholder={"Seleccione el calendario"}
                        onChange={(e) => {
                            let label = e.originalEvent.nativeEvent.target.textContent;
                            setCalendar({ "value": e.value, "label": label })
                        }} />
                    <Button icon="pi pi-search" loading={loadingConsultar} disabled={calendar.value == false || calendar.value == undefined} className="mr-2 p-button-sm text-xs" tooltip="Consultar procesos anteriores" tooltipOptions={{ position: 'top' }} onClick={() => setTabla()} />
                </div>

            </Dialog>
            <Dialog header={headerAcum} footer={footerAcum} visible={isOpenAcum} position="top"
                style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalAcum} />
            <Dialog header={headerRA} footer={footerRA} visible={isOpenRA} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalRA}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                {params.map((d, index) => {
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && accounting.length > 0 && typeof accounting[index] !== "undefined") {
                        let label = d.LABEL

                        if (d.REQUIRED == "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={accounting[index]["NAME"]}
                                        options={options}
                                        filter filterBy="NAME"
                                        optionLabel="NAME"
                                        placeholder={accounting[index]["NAME"] ? accounting[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChange(e, d, index)}
                                    />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Calendar key={d} style={elementWidth} id="navigators" value={accounting[index].CODE}
                                        onChange={(e) => handleChangeDate(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={accounting[index].CODE}
                                         yearRange="2010:2090" /></>
                                );
                            default:
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={accounting[index]}
                                        onChange={(e) => handleChangeText(e, d, index)}
                                    /></>
                                )
                        }
                    }
                })}
            </Dialog>

            <Dialog header={"Errores"} visible={isOpenErrors}
                position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
                <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

                    <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
                        <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
                        <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
                    </DataTable>
                </div>
            </Dialog>

            <div className="flex flex-row align-items-center justify-content-center mb-3 mt-2 font-bold text-4xl">
                <span className="text-900">Liquidación</span>
                <Video header="Instructivo proceso contable" url={localStorage.getItem('ACCOUNTING_VIDEO')} />
            </div>

            <Form onSubmit={handleSubmit}>
                <div className='cards2'>
                    <Card className='shadow-5' style={{ width: '60vw', height: '60vh', alignItems: 'center' }}>
                        <span className="text-900 mb-2 font-bold text-xl">{nameTable}</span>
                        <div className="datatable-style-demo mt-4 flex justify-content-center align-items-center">
                            <SkeletonTable load={loadPage} height={'30vh'}>
                                <DataTable className="text-xs" value={dataTable}
                                    size="small" rowClassName={rowClassName2} style={{ width: '100%' }}
                                >
                                    <Column field="COL1" header={headersTable["COL1"]} showFilterOperator={false}></Column>
                                    <Column field="COL2" header={headersTable["COL2"]} headerStyle={{ width: '50px', textAlign: 'center' }} body={valueBodyTemplateCol2} bodyStyle={{ textAlign: 'right' }} showFilterOperator={false}></Column>
                                    <Column field="COL3" header={headersTable["COL3"]} headerStyle={{ width: '50px', textAlign: 'center' }} body={valueBodyTemplateCol3} bodyStyle={{ textAlign: 'right' }} showFilterOperator={false}></Column>
                                    <Column field="COL4" header={headersTable["COL4"]} headerStyle={{ width: '50px', textAlign: 'center' }} body={valueBodyTemplateCol4} bodyStyle={{ textAlign: 'right' }} showFilterOperator={false}></Column>
                                </DataTable>
                            </SkeletonTable>
                        </div>
                    </Card>
                    &nbsp;
                    <Card className='card2 shadow-5'>
                        <Forms>
                            <H3>Contabilidad</H3>
                            <div className='flex flex-column justify-content-center align-items-center'>
                                <Button block type="submit" onClick={showModal}>
                                    Liquidar Contabilidad
                                </Button>
                                &nbsp;
                                <Button block type="submit" onClick={showModalPlano}>
                                    Plano Contable
                                </Button>
                                &nbsp;
                            </div>
                            <H3>Consulta</H3>
                            <Button block type="submit" onClick={showModalRA} >
                                Reporte detallado Contabilidad
                            </Button>
                        </Forms>
                    </Card>
                </div>
            </Form>
        </div>
    );
}